import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

import LoginView from '../views/LoginView.vue'

import CustomerOrderDayView from '../views/customer/CustomerOrderDayView.vue'
import CustomerWeekReportView from '../views/customer/CustomerWeekReportView.vue'
import CustomerWeekPrintView from '../views/customer/CustomerWeekPrintView.vue'
import CustomerChildrenView from '../views/customer/CustomerChildrenView.vue'
import CustomerProfileView from '../views/customer/CustomerProfileView.vue'

import KitchenSummaryView from '../views/kitchen/KitchenSummaryView.vue'
import KitchenDayView from '../views/kitchen/KitchenDayView.vue'
import KitchenOrderEditView from '../views/kitchen/KitchenOrderEditView.vue'
import KitchenPrintDayView from '../views/kitchen/KitchenPrintDayView.vue'
import KitchenAuditView from '../views/kitchen/KitchenAuditView.vue'
import KitchenChildrenView from '../views/kitchen/KitchenChildrenView.vue'
import KitchenContractorsView from '../views/kitchen/KitchenContractorsView.vue'
import KitchenSpecialTypesView from '../views/kitchen/KitchenSpecialTypesView.vue'
import KitchenTagsView from '../views/kitchen/KitchenTagsView.vue'
import KitchenUsersView from '../views/kitchen/KitchenUsersView.vue'

const routes = [
  { path: '/login', component: LoginView },
  { path: '/', redirect: '/customer/day' },

  { path: '/customer/day', component: CustomerOrderDayView, meta: { role: 'CUSTOMER' } },
  { path: '/customer/week-report', component: CustomerWeekReportView, meta: { role: 'CUSTOMER' } },
  { path: '/customer/week-print', component: CustomerWeekPrintView, meta: { role: 'CUSTOMER' } },
  { path: '/customer/children', component: CustomerChildrenView, meta: { role: 'CUSTOMER' } },
  { path: '/customer/profile', component: CustomerProfileView, meta: { role: 'CUSTOMER' } },

  { path: '/kitchen/summary', component: KitchenSummaryView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/day', component: KitchenDayView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/order-edit', component: KitchenOrderEditView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/audit', component: KitchenAuditView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/print-day', component: KitchenPrintDayView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/children', component: KitchenChildrenView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/contractors', component: KitchenContractorsView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/special-types', component: KitchenSpecialTypesView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/tags', component: KitchenTagsView, meta: { role: 'KITCHEN' } },
  { path: '/kitchen/users', component: KitchenUsersView, meta: { role: 'KITCHEN' } }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(to => {
  const auth = useAuthStore()

  if (to.path !== '/login' && !auth.isLogged) return '/login'

  const needRole = to.meta?.role
  if (needRole && auth.role !== needRole) {
    return auth.role === 'KITCHEN' ? '/kitchen/day' : '/customer/day'
  }
})

export default router
